export default __webpack_public_path__ + "26d519579325134441ec49b0ac4fd705.svg";